import React from 'react';
import './ListSummary.scss';

const ListSummary = ({children, type = 'default'}) => {
  return <footer className={`list__summary list__summary--${type}`}>{children}</footer>;
};

export default ListSummary;
